import {makeAutoObservable} from 'mobx'

///////////////////////////////////////////////////////////////////////////////

export type FnExecuteRecaptcha = (action?: string) => Promise<string>

///////////////////////////////////////////////////////////////////////////////

export class RecaptchaStore {
  isReady = false
  #executeRecaptcha?: FnExecuteRecaptcha

  constructor() {
    makeAutoObservable(this)
  }

  setExecutor(fn: FnExecuteRecaptcha) {
    this.#executeRecaptcha = fn
    this.isReady = true
  }

  async getToken(action: string) {
    const token = await this.#executeRecaptcha?.(action)
    return token
  }
}
